import { useState, useEffect } from "react";
import "./Investors.css";
import { FaChevronRight, FaChevronDown, FaDownload, FaGlobe, FaExternalLinkAlt } from "react-icons/fa";
import pdfIcon from "../assets/pdf-icon.png";

export default function Investors() {
  const [openIndex, setOpenIndex] = useState(null); 
  const [activeParent, setActiveParent] = useState(null);
  const [activeChild, setActiveChild] = useState("Annual Reports");

  // ---- QIP disclaimer flow state ----
  const [qipStep, setQipStep] = useState("disclaimer"); 
  const [qipAgreed, setQipAgreed] = useState(false);
  const [qipCountry, setQipCountry] = useState("");

  
   const PLACEMENT_DOC_URL = "/reports/SCL_Preliminary_Placement_Document.pdf";

  const handleQipCountrySelect = (country) => {
    setQipCountry(country);
    if (country === "India") {
      window.open(PLACEMENT_DOC_URL, "_blank", "noopener,noreferrer");
    } else if (country) {
      setQipStep("restricted");
    }
  };

  
  useEffect(() => {
    if (activeChild === "Qualified Institutional Placement") {
      setQipStep("disclaimer");
      setQipAgreed(false);
      setQipCountry("");
    }
  }, [activeChild]);

  const sidebarItems = [
    {
      title: "Reports",
      children: ["Annual Reports", "Business Responsibility and Sustainability Report", "Notice of Annual General Meeting", "AGM Transcript"],
    },
    {
      title: "Disclosures",
      children: [
        "Disclosures under Regulations 46 of the LODR",
        "Familiarisation Programme",
        "Financial Information",
        "Shareholding pattern",
        "Details of agreements entered into with the media companies and/or their associates",
        "Investors Meet",
        "New Name and the old name of the listed entity for a continuous period of one year, from the date of the last name change",
        "Statutory Advertisements",
        "Credit Ratings",
        "Financial Statements of Subsidiaries",
        "Secretarial Compliance Report",
        "Disclosure of the policy for determination of materiality of events or information",
        "Key Managerial Personnel authorised for determining materiality of events or information",
        "Statement of deviation(s) or variation(s) as specified in regulation 32",
        "Dividend Distribution Policy",
        "Annual return as provided under section 92 of the Companies Act, 2013",
        "Name of the debenture trustees with full contact details",
        "Corporate Social Responsibility Policy",
        "Approved CSR Projects"
      ],
    },
    {
      title: "Stock Exchange Intimation",
      children: ["SEI 2024","SEI 2025","SEI 2026"],
    },
    {
      title: "Information",
      children: ["Board of Directors", "Key Managerial Personnel", "Investor Service Request"],
    },
    {
      title: "Announcements",
      children: ["Composite Scheme of Arrangement", "Qualified Institutional Placement"],
    },
    {
      title: "Corporate Governance",
      children: ["Corporate Governance Report", "Business Responsibility and Sustainability Report", "Notice of Annual General Meeting", "AGM Transcript"],
    },
    {
      title: "Postal Ballot",
      children: ["2026","2024", "2023"],
    },
  ];
  

  const reports = [
    { year: "2026", url: "/reports/AnnualReport2025-26.pdf" },
    { year: "2025", url: "/reports/AnnualReport2025.pdf" },
    { year: "2024", url: "/reports/AnnualReport2024.pdf" },
    
  
  ];

  const disclosuresContent = {
   "Disclosures under Regulations 46 of the LODR": [
  { title: "Details of Company's business", url: "https://www.sundaram-clayton.com/Profile.htm", isPage: true, subtitle: "Official website — About Us page" },
  { title: "Terms and Conditions of appointment of Independent Directors", url: "/reports/disclosures/Terms_of_Appointment_of_IndependentDirector.pdf" },
  { title: "Composition of Committees", url: "/reports/disclosures/3. Composition_of_Committees.pdf" },
  { title: "Code of Conduct - Board & Senior Management", url: "/reports/disclosures/Code_of_Business_Conduct_and_Ethics.pdf" },
  { title: "Whistle Blower Policy", url: "/reports/disclosures/Whistle_Blower_Policy.pdf" },
  { title: "Policy on Related Party Transactions", url: "/reports/disclosures/PolicyonRelatedPartyTransactions.pdf" },
  { title: "Policy on Material Subsidiaries", url: "/reports/disclosures/Material_Subsidiary_Policy.pdf" },
  { title: "Memorandum and Articles of Association", url: "/reports/disclosures/Memorandum_Articles_of_Association.pdf" },
],

"Familiarisation Programme": [
  { title: "Independent Directors Familiarisation Programme", url: "/reports/disclosures/Independent_Directors_Familiarisation_programme.pdf" },
  { title: "Familiarisation Programme", url: "/reports/disclosures/Familiarisation_Program.pdf" },
],

"Financial Information": [
  { title: "Notice of Board Meeting - 28th July 2026", url: "/reports/disclosures/Notice_of_BoardMeeting_28th_July_2026.pdf" },
  { title: "Notice of Board Meeting - 14th May 2026", url: "/reports/disclosures/Notice_of_BoardMeeting_14th_May_2026.pdf" },
  { title: "Notice of Board Meeting - 29th January 2026", url: "/reports/disclosures/Notice_of_BoardMeeting_29th_Jan_2026.pdf" },
  { title: "Notice of Board Meeting - 6th November 2025", url: "/reports/disclosures/Notice_of_BoardMeeting_6th_Nov_2025.pdf" },
  { title: "Notice of Board Meeting - 6th August 2025", url: "/reports/disclosures/Notice_of_BoardMeeting_6th_August_2025.pdf" },
  { title: "Notice of Board Meeting - 6th May 2025", url: "/reports/disclosures/Notice_of_BoardMeeting_6th_May_2025.pdf" },
  { title: "Notice of Board Meeting - 21st March 2025", url: "/reports/disclosures/Notice_of_BoardMeeting_21st_Mar_2025.pdf" },
  { title: "Notice of Board Meeting - 31st January 2025", url: "/reports/disclosures/Notice_of_BoardMeeting_31st_Jan_2025.pdf" },
  { title: "Notice of Board Meeting - 12th November 2024", url: "/reports/disclosures/Notice_of_BoardMeeting_12th_Nov_2024.pdf" },
  { title: "Notice of Board Meeting - 9th August 2024", url: "/reports/disclosures/Notice_of_the_BoardMeeting_9th_August_2024.pdf" },
  { title: "Notice of Board Meeting - 3rd July 2024", url: "/reports/disclosures/Notice_of_BoardMeeting_3rd_July_2024.pdf" },
  { title: "Notice of Board Meeting - 10th May 2024", url: "/reports/disclosures/Notice_of_BoardMeeting_10th_May_2024.pdf" },
  { title: "Notice of Board Meeting - 26th March 2024", url: "/reports/disclosures/Notice_of_Board_Meeting_26th_March_2024.pdf" },
  { title: "Notice of Board Meeting - 9th February 2024", url: "/reports/disclosures/Notice_of_Board_Meeting_9th_February_2024.pdf" },
  { title: "Financial Results - Quarter ended 30th June 2026", url: "/reports/disclosures/Quarterended_30th_Jun_2026.pdf" },
  { title: "Financial Results - Quarter and year ended 31st March 2026", url: "/reports/disclosures/Quarterended31stMarch2026.pdf" },
  { title: "Financial Results - Quarter ended 31st December 2025", url: "/reports/disclosures/Quarterended31stDecember2025.pdf" },
  { title: "Financial Results - Quarter ended 30th September 2025", url: "/reports/disclosures/Quarterended30thSeptember2025.pdf" },
  { title: "Financial Results - Quarter ended 30th June 2025", url: "/reports/disclosures/Quarterended_30th_Jun_2025.pdf" },
  { title: "Financial Results - Quarter ended 31st March 2025", url: "/reports/disclosures/Quarterended_31st_Mar_2025.pdf" },
  { title: "Financial Results - Quarter ended 31st December 2024", url: "/reports/disclosures/Quarterended_31st_Dec_2024.pdf" },
  { title: "Financial Results - Quarter ended 30th September 2024", url: "/reports/disclosures/Quarterended30thSeptember2024.pdf" },
  { title: "Financial Results - Quarter ended 30th June 2024", url: "/reports/disclosures/Quarter_ended_30th_June_2024.pdf" },
  { title: "Financial Results - Quarter and year ended 31st March 2024", url: "/reports/disclosures/Quarter_year_ended_31st_March_2024.pdf" },
  { title: "Financial Results - Quarter ended 31st December 2023", url: "/reports/disclosures/Quarterended_31st_December2023.pdf" },
  { title: "Integrated Filing (Financial) - Quarter ended 31st December 2024", url: "/reports/disclosures/Quarter_ended_31st_December_2024.pdf" },
],

"Shareholding pattern": [
  { title: "Disclosure of shareholding pattern - June 2026", url: "/reports/disclosures/Distribution_Shareholding_Pattern_Jun_2026.pdf" },
  { title: "Disclosure of shareholding pattern - March 2026", url: "/reports/disclosures/Distribution_Shareholding_Pattern_Mar_2026.pdf" },
  { title: "Disclosure of shareholding pattern - December 2025", url: "/reports/disclosures/Distribution_Shareholding_Pattern_Dec_2025.pdf" },
  { title: "Disclosure of shareholding pattern - September 2025", url: "/reports/disclosures/Distribution_Shareholding_Pattern_Sep_2025.pdf" },
  { title: "Disclosure of shareholding pattern - June 2025", url: "/reports/disclosures/Distribution_Shareholding_Pattern_June_2025.pdf" },
  { title: "Disclosure of shareholding pattern - March 2025", url: "/reports/disclosures/Distribution_Shareholding_Pattern_March_2025.pdf" },
  { title: "Disclosure of shareholding pattern - December 2024", url: "/reports/disclosures/Distribution_Shareholding_Pattern_December_2024.pdf" },
  { title: "Disclosure of shareholding pattern - September 2024", url: "/reports/disclosures/Disclosure_shareholding_pattern_Sep_2024.pdf" },
  { title: "Disclosure of shareholding pattern - June 2024", url: "/reports/disclosures/Disclosure_shareholding_pattern_June_2024.pdf" },
  { title: "Disclosure of shareholding pattern - March 2024", url: "/reports/disclosures/Distribution_Shareholding_Pattern_March_2024.pdf" },
  { title: "Distribution of Shareholding pattern - December 2023", url: "/reports/disclosures/Distribution_Shareholding_Pattern_December_2023.pdf" },
  { title: "Shareholding Pattern as on record date", url: "/reports/disclosures/Shareholding_Pattern_as_on_record_date.pdf" },
],
    "Details of agreements entered into with the media companies and/or their associates": [
      { title: "Details of agreements entered into with the media companies and/or their associates", text: "NIL" },
    ],
    "Business Responsibility and Sustainability Report": [
      { title: "Business Responsibility and Sustainability Report 2025-26", url: "/reports/BRSR_2025-26.pdf" },
      { title: "Business Responsibility and Sustainability Report 2024-25", url: "/reports/BRSR_2024-25.pdf" },
      { title: "Business Responsibility and Sustainability Report 2023-24", url: "/reports/BRSR_2023-24.pdf" },
    ],

    "Corporate Governance Report": [
      { title: "Corporate Governance report for QE 30.06.2026", url: "/reports/Corporate_Governance_report_for_QE_30_06_2026.pdf" },
      { title: "Corporate Governance report for QE 31.03.2026", url: "/reports/Corporate_Governance_report_for_QE_31_03_2026.pdf" },
      { title: "Corporate Governance report for QE 31.12.2025", url: "/reports/Corporate_Governance_report_for_QE_31_12_2025.pdf" },
      { title: "Corporate Governance report for QE 30.09.2025", url: "/reports/Corporate_Governance_report_for_QE_30_09_2025.pdf" },
      { title: "Corporate Governance report for QE 30.06.2025", url: "/reports/Corporate_Governance_report_for_QE_30_06_2025.pdf" },
      { title: "Corporate Governance report for QE 31.03.2025", url: "/reports/Corporate_Governance_report_for_QE_31_03_2025.pdf" },
      { title: "Corporate Governance report for QE 31.12.2024", url: "/reports/Corporate_Governance_report_for_QE_31_12_2024.pdf" },
      { title: "Corporate Governance report for QE 30.09.2024", url: "/reports/Corporate_Governance_report_for_QE_30_09_2024.pdf" },
      { title: "Corporate Governance report for QE 30.06.2024", url: "/reports/Corporate_Governance_report_for_QE_30_06_2024.pdf" },
      { title: "Corporate Governance report for QE 31.03.2024", url: "/reports/Corporate_Governance_report_for_QE_31_03_2024.pdf" },
      { title: "Corporate Governance report for QE 31.12.2023", url: "/reports/Corporate_Governance_report_for_QE_31_12_2023.pdf" },
    ],
    "Notice of Annual General Meeting": [
      { title: "Notice of 9th Annual General Meeting 2026", url: "/reports/Notice_9th_AGM_2026.pdf" },
      { title: "Notice of 8th Annual General Meeting 2025", url: "/reports/Notice_8th_AGM_2025.pdf" },
      { title: "Notice of 7th Annual General Meeting 2024", url: "/reports/Notice_7th_AGM_2024.pdf" },
    ],
    "AGM Transcript": [
      { title: "Transcript of 9th Annual General Meeting", url: "/reports/5. Transcript of 9th Annual General Meeting.pdf" },
      { title: "Transcript of 8th Annual General Meeting", url: "/reports/Transcript_8th_AGM.pdf" },
      { title: "Transcript of 7th Annual General Meeting", url: "/reports/Transcript_7th_AGM.pdf" },
    ],

    "2026": [
  {
    title: "Postal Ballot Notice - February 2026",
    url: "/reports/Notice_PostalBallot_26Feb_2026.pdf",
  },
  {
    title: "Postal Ballot Advertisement - February 2026",
    url: "/reports/PostalBallotAdvertisement_Feb_2026.pdf",
  },
  {
    title: "Outcome of Postal Ballot - February 2026",
    url: "/reports/PostalBallot_Outcome_Feb_2026.pdf",
  },
],
"2024": [
  {
    title: "Postal Ballot Outcome - November 2024",
    url: "/reports/POSTAL_BALLOT_OUTCOME_NOV2024.pdf",
  },
  {
    title: "Postal Ballot Advertisement - November 2024",
    url: "/reports/POSTAL_BALLOT_ADVERTISEMENT_NOV2024.pdf",
  },
  {
    title: "Notice of Postal Ballot - 12th November 2024",
    url: "/reports/Postal Ballot Notice November 2024.pdf",
  },
  {
    title: "Postal Ballot Outcome - July 2024",
    url: "/reports/POSTAL_BALLOT_OUTCOME_JULY2024.pdf",
  },
  {
    title: "Postal Ballot Advertisement - July 2024",
    url: "/reports/POSTAL_BALLOT_ADVERTISEMENT_JULY2024.pdf",
  },
  {
    title: "Notice of Postal Ballot - 3rd July 2024",
    url: "/reports/Postal Ballot Notice July 2024.pdf",
  },
  {
    title: "Postal Ballot Outcome - March 2024",
    url: "/reports/POSTAL_BALLOT_OUTCOME_MARCH2024.pdf",
  },
  {
    title: "Postal Ballot Advertisement - March 2024",
    url: "/reports/POSTAL_BALLOT_ADVERTISEMENT_MARCH2024.pdf",
  },
  {
    title: "Notice of Postal Ballot - 26th March 2024",
    url: "/reports/Postal Ballot Notice March 2024.pdf",
  },
  {
    title: "Postal Ballot Outcome - Feb 2024",
    url: "/reports/POSTAL_BALLOT_OUTCOME_FEB2024.pdf",
  },
  {
    title: "Postal Ballot Advertisement - Feb 2024",
    url: "/reports/POSTAL_BALLOT_ADVERTISEMENT_FEB2024.pdf",
  },
  {
    title: "Notice of Postal Ballot - 9th February 2024",
    url: "/reports/Postal Ballot Notice February 2024.pdf",
  },
],

    "2023": [
  {
    title: "Postal Ballot Advertisement - November 2023",
    url: "/reports/POSTAL_BALLOT_ADVERTISEMENT_NOV2023.pdf",
  },
  {
    title: "Postal Ballot Notice - November 2023",
    url: "/reports/Postal Ballot Notice November 2023.pdf",
  },
  {
    title: "Outcome of Postal Ballot - November 2023",
    url: "/reports/Outcome_of_Postal_Ballot-Nov_2023.pdf",
  },
],

"SEI 2024": [
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - December 30, 2024", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_December_30_2024.pdf" },
  { title: "Change in Directorate - Intimation under Regulation 30 of SEBI (LODR) Regulations, 2015", url: "/reports/sei/ChangeinDirectorate-IntimationunderRegulation30ofSEBI(LODR)Regulations2015.pdf" },
  { title: "Intimation of Postal ballot as per Section 110 of the Companies Act, 2013", url: "/reports/sei/IntimationofPostalballotasperSection110oftheCompaniesAct2013.pdf" },
  { title: "Outcome of Board Meeting - November 12, 2024", url: "/reports/sei/OutcomeofBoardMeeting-November122024.pdf" },
  { title: "Announcement under Regulation 30 (LODR)-Credit Rating - October 10, 2024", url: "/reports/sei/Announcement_under_Regulation_30_LODR_Credit_Rating_October_10_2024.pdf" },
  { title: "Qualified Institutions Placement Of Equity Shares - Updates - October 8, 2024", url: "/reports/sei/Qualified_Institutions_Placement_Of_Equity_Shares_Updates_October_8_2024.pdf" },
  { title: "Announcement under Regulation 30 (LODR)-Allotment - October 8, 2024", url: "/reports/sei/Announcement_under_Regulation_30_LODR_Allotment_October_8_2024.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - October 4, 2024", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_October_4_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - October 3, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_October_3_2024.pdf" },
  { title: "Intimation under Regulation 30 of SEBI Regulation, 2015 - October 3, 2024", url: "/reports/sei/Intimation_under_Regulation_30_of_SEBI_Regulation_2015_October_3_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - October 2, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_Oct_02_2024.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - September 30, 2024", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_Sep_30_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - September 12, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_Sep_12_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - September 5, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_Sep_5_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - August 30, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_Aug_30_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - August 20, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_Aug_20_2024.pdf" },
  { title: "AGM - Voting results and Scrutinizer's report - August 9, 2024", url: "/reports/sei/AGM_Voting_results_Scrutinizer_report_August_9_2024.pdf" },
  { title: "Outcome of Annual General Meeting - August 9, 2024", url: "/reports/sei/Outcome_of_AGM_August_9_2024.pdf" },
  { title: "Outcome of Board Meeting - August 9, 2024", url: "/reports/sei/Outcome_of_BoardMeeting_August_9_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - July 23, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_July_23_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - July 22, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_July_22_2024.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - July 4, 2024", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_July_4_2024.pdf" },
  { title: "Outcome of Board Meeting - July 3, 2024", url: "/reports/sei/Outcome_of_BoardMeeting_3rd_July_2024.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - June 30, 2024", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_June_30_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - May 23, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_May_23_2024.pdf" },
  { title: "Intimation Under Regulation 31A of SEBI Regulations - May 17, 2024", url: "/reports/sei/Intimation_Under_Regulation_31A_of_SEBI_Regulations_May_17_2024.pdf" },
  { title: "Compliance under Regulation 33 and 52 of SEBI Regulation, 2015 - May 10, 2024", url: "/reports/sei/Compliance_under_Regulation_33_52_of_SEBI_Regulation_2015_May_10_2024.pdf" },
  { title: "Annual General Meeting To Be Held On 9Th August 2024 - May 10, 2024", url: "/reports/sei/Annual_General_Meeting_To_Be_Held_On_9Th_August_2024_May_10_2024.pdf" },
  { title: "Outcome of Board Meeting - May10, 2024", url: "/reports/sei/Outcome_of_BoardMeeting_May10_2024.pdf" },
  { title: "Non-applicability of disclosure requirements as a Large Corporate - April 30, 2024", url: "/reports/sei/Non-applicability_of_disclosure_requirements_as_a_LargeCorporate_April_30_2024.pdf" },
  { title: "Compliance under Regulation 40(9) of SEBI Regulations - April 25, 2024", url: "/reports/sei/Compliance_under_Regulation_40_9_of_SEBI_Regulations_April_25_2024.pdf" },
  { title: "Change in Directorate - Intimation under Regulation 30 of SEBI (LODR) Regulations, 2015", url: "/reports/sei/Change_in_Directorate.pdf" },
  { title: "Intimation of Postal ballot as per Section 110 of the Companies Act, 2013", url: "/reports/sei/Intimation_Postalballot_Section_110_Companies_Act_2013.pdf" },
  { title: "Regulation 7(3) of SEBI (LODR) Regulations, 2015 - April 4 2024", url: "/reports/sei/Regulation_7_3_of_SEBI_LODR_Regulations_2015_April_4_2024.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - April 4 2024", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_April_4_2024.pdf" },
  { title: "Intimation of record date for declaration of Interim Dividend for the year ending March 31, 2024", url: "/reports/sei/Intimation_of_record_date_for_declaration_of_InterimDividend_for_the_year_ending_March_31_2024.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - March 29,2024", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_March_29_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - March 27, 2024", url: "/reports/sei/Regulation30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_March_27_2024.pdf" },
  { title: "Outcome of Board Meeting - March 26, 2024", url: "/reports/sei/Outcome_of_BoardMeeting_March_26_2024.pdf" },
  { title: "Intimation under Regulation 30 and 51 of SEBI (LODR) Regulations, 2015 - March 26, 2024", url: "/reports/sei/Intimation_under_Regulation_30_51_of_SEBI_LODR_Regulations_2015_March_26_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - March 22, 2024", url: "/reports/sei/Regulation30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_March_22_2024.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - March 18,2024", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_March_18_2024.pdf" },
  { title: "Compliance under Regulation 30 of SEBI Regulation, 2015 - February 9, 2024", url: "/reports/sei/Compliance_under_Regulation_30_of_SEBI_Regulation_2015_February_9_2024.pdf" },
  { title: "Compliance under Regulation 33 and 52 of SEBI Regulation, 2015 - February 9, 2024", url: "/reports/sei/Compliance_under_Regulation_33_52_SEBI_Regulation_2015_February_9_2024.pdf" },
  { title: "Intimation under Regulation 30 read with Regulation 31(A)(8) under SEBI Regulation, 2015 - February 9, 2024", url: "/reports/sei/Intimation_under_Regulation_30_read_with_Regulation_31_A_8_under_SEBI_Regulation_2015_February9_2024.pdf" },
  { title: "Intimation under Regulation 30 read with Regulation 31(A)(8) under SEBI Regulation, 2015 - January 17, 2024", url: "/reports/sei/Intimation_under_Regulation_30_read_with_Regulation_31_A_8_under_SEBI_Regulation_2015_January_17_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - January 8, 2024", url: "/reports/sei/Regulation30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_January_8_2024.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - January 3, 2024", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_Participants_Regulations_2018_January_3_2024.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - January 2, 2024", url: "/reports/sei/Regulation30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_January_2_2024.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - December 31, 2023", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_December_31_2023.pdf" },
  { title: "Intimation under Regulation 30(5) of SEBI (LODR) Regulations, 2015 - December 29, 2023", url: "/reports/sei/Intimation_under_Regulation_30_5_of_SEBI_LODR_Regulations_2015_December_29_2023.pdf" },
{title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - October 3, 2024", url: "/reports/sei/Regulation_30_Disclosure_of_events_or_information_under_SEBI_Regulation_2015_October_3_2024.pdf" },
],
"SEI 2025": [
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - December 30, 2025", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_30Dec2025.pdf" },
  { title: "Regulation 30 (LODR) - Acquisition - November 28 2025", url: "/reports/sei/Regulation_30_LODR_Acquisition_28Nov2025.pdf" },
  { title: "Regulation 30 (LODR) - Change in Directorship - November 28 2025", url: "/reports/sei/Regulation_30_LODR_Change_in_Directorship_28Nov2025.pdf" },
  { title: "Regulation 30 (LODR) -Press Release - Media Release - November 6,2025", url: "/reports/sei/Regulation_30_LODR_Press_Release_Media_Release_06Nov2025.pdf" },
  { title: "Outcome of Board Meeting - November 6,2025", url: "/reports/sei/Outcome_of_BoardMeeting_06Nov2025.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - October 8, 2025", url: "/reports/sei/Regulation_74_5_SEBI_Depository_Participants_Regulations_2018_October_8_2025.pdf" },
  { title: "Intimation Under Regulation 31A of SEBI Regulations - September 30, 2025", url: "/reports/sei/Intimation_Under_Regulation_31A_of_SEBI_Regulations_September_30_2025.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - September 29, 2025", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_29_09_2025.pdf" },
  { title: "Announcement under Regulation 30 (LODR)-Analyst Investor Meet - Intimation - September 18 2025", url: "/reports/sei/Announcement_under_Regulation_30_LODR_Analyst_Investor_Meet_Intimation_September_18_2025.pdf" },
  { title: "AGM - Voting results and Scrutinizer's report - August 6, 2025", url: "/reports/sei/AGM_Voting_results_Scrutinizer_report_August_6_2025.pdf" },
  { title: "Outcome of Annual General Meeting - August 6, 2025", url: "/reports/sei/Outcome_of_AGM_6th_Aug_2025.pdf" },
  { title: "Outcome of Board Meeting - Aug 6 2025", url: "/reports/sei/Outcome_of_BoardMeeting_06Aug2025.pdf" },
  { title: "Regulation 30 (LODR) - Change in Management - July 8 2025", url: "/reports/sei/Regulation_30_LODR_Change_in_Management_July_8_2025.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - July 7, 2025", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_Participants_Regulations_2018_July_7_2025.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - June 27, 2025", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_27_06_2025.pdf" },
  { title: "Regulation 30 (LODR) -Press Release - Media Release - May 6 2025", url: "/reports/sei/Regulation_30_LODR_Press_Release_Media_Release_06052025.pdf" },
  { title: "Regulation 30 (LODR) -Change in Management - May 6 2025", url: "/reports/sei/Regulation_30_LODR_Change_in_Management_06052025.pdf" },
  { title: "Outcome of Board Meeting - May 6 2025", url: "/reports/sei/Outcome_of_BoardMeeting_06052025.pdf" },
  { title: "Regulation 30 (LODR) - Disclosure of events or information under SEBI Regulation, 2015 - May 6 2025", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_06052025.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - April 8, 2025", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_Participants_Regulations_2018_April_8_2025.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - March 27 2025", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_March_27_2025.pdf" },
  { title: "Outcome of Board Meeting - 21.03.2025", url: "/reports/sei/Outcome_of_BoardMeeting_21_03_2025.pdf" },
  { title: "Regulation 30 - Disclosure of events or information under SEBI Regulation, 2015 - March 17 2025", url: "/reports/sei/Regulation_30_Disclosure_of_events_information_under_SEBI_Regulation_2015_Mar_17_2025.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - March 17, 2025", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_17_03_2025.pdf" },
  { title: "Outcome of Board Meeting - 19.02.2025", url: "/reports/sei/Outcome_of_Board_Meeting_19_02_2025.pdf" },
  { title: "QIP - Monitoring Agency Report dt. 31.01.2025", url: "/reports/sei/QIP_Monitoring_Agency_Report_31_01_2025.pdf" },
  { title: "Press Release - Thervoy Kandigai Plant", url: "/reports/sei/PressRelease_Thervoy_Kandigai_Plant.pdf" },
  { title: "Outcome of Board Meeting - January 31, 2025", url: "/reports/sei/Outcome_of_Board_Meeting_Jan_31_2025.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - January 8, 2025", url: "/reports/sei/Regulation_74_5__of_SEBI_Regulations,_2018_Jan_8_2025.pdf" },
],

"SEI 2026": [
  { title: "Regulation 30 (LODR) -Press Release - Media Release - July 28,2026", url: "/reports/sei/Regulation30_LODR_Press_Release_MediaRelease_July_28_2026.pdf" },
   { title: "Compliance under SEBI (PIT) Regulation, 2015 - September 30, 2026", url: "/reports/sei/10.2 Compliance under SEBI (PIT) Regulation, 2015 - September 30, 2026.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - September 30, 2026", url: "/reports/sei/10.1 Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - September 30, 2026.pdf" },
  { title: "Change in Directorate - Resignation of Mr P Kaniappan", url: "/reports/sei/10.3 Change in Directorate - Resignation of Mr P Kaniappan.pdf" },
  { title: "Outcome of Annual General Meeting July 28, 2026", url: "/reports/sei/Outcome_of_AGM_28Jul2026.pdf" },
  { title: "AGM - Reappointment of Statutory Auditors", url: "/reports/sei/AGM_Reappointment_of_Statutory_Auditors.pdf" },
  { title: "AGM - Voting results and Scrutinizer's report - July 28, 2026", url: "/reports/sei/AGM_Voting_results_and_Scrutinizer_report_July_28_2026.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - June 30, 2026", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_30jun2026.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - June 30, 2026", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_30Jun2026.pdf" },
  { title: "Outcome of Board Meeting - July 28 2026", url: "/reports/sei/Outcome_of_BoardMeeting_28Jul2026.pdf" },
  { title: "Regulation 30 (LODR) - Re-appointment of Statutory Auditor - May 14 2026", url: "/reports/sei/Regulation_30_LODR_Reappointment_of_Statutory_Auditor_14May2026.pdf" },
  { title: "Regulation 30 (LODR) -Press Release - Media Release - May 14,2026", url: "/reports/sei/Regulation_30_LODR_PressRelease_MediaRelease_14May2026.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - April 6, 2026", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_06Apr2026.pdf" },
  { title: "Outcome of Board Meeting - March 30 2026", url: "/reports/sei/Outcome_of_BoardMeeting_30Mar2026.pdf" },
  { title: "Compliance under SEBI (PIT) Regulation, 2015 - March 31, 2026", url: "/reports/sei/Compliance_under_SEBI_PIT_Regulation_2015_31_Mar_2026.pdf" },
  { title: "Outcome of Board Meeting - March 27 2026", url: "/reports/sei/Outcome_of_BoardMeeting_27Mar2026.pdf" },
  { title: "Regulation 30 (LODR) - Change in Key Managerial Personnel - March 27 2026", url: "/reports/sei/Regulation_30_LODR_Change_in_Key_Managerial_Personnel_Mar_27_2026.pdf" },
  { title: "Regulation 30 (LODR) - Change in Directorate - February 26, 2026", url: "/reports/sei/Regulation_30_LODR_Change_in_Directorate_February_26_2026.pdf" },
  { title: "Regulation 30 (LODR) - Restructuring - February 5, 2026", url: "/reports/sei/Regulation_30_LODR_Restructuring_February_5_2026.pdf" },
  { title: "Outcome of Board Meeting - January 29 2026", url: "/reports/sei/Outcome_of_BoardMeeting_29Jan2026.pdf" },
  { title: "Regulation 30 (LODR) - Sale of land - January 8 2026", url: "/reports/sei/Regulation_30_LODR_Sale_of_Land_08Jan2026.pdf" },
  { title: "Regulation 74(5) of SEBI (Depository and Participants) Regulations, 2018 - January 6, 2026", url: "/reports/sei/Regulation_74_5_of_SEBI_Depository_and_Participants_Regulations_2018_06Jan2026.pdf" },
],
    "Investors Meet": [
      { title: "Schedule of Analyst or Institutional Investor meet", text: "NIL" },
      { title: "Recordings / Transcript of Analyst or Institutional Investor meet", text: "NIL" },
    ],
    "New Name and the old name of the listed entity for a continuous period of one year, from the date of the last name change": [
      { title: "Sundaram-Clayton Limited", text: "New name" },
      { title: "Sundaram-Clayton DCD Limited", text: "Previous name" },
      { title: "Sundaram-Clayton DCD Private Limited", text: "Previous name" },
      { title: "TVS Commodity Financial Solutions Private Limited", text: "Previous name" },
    ],
   "Statutory Advertisements": [
  { title: "Pre Dispatch AGM 2026 Advertisement", url: "/reports/6.1 Pre Dispatch AGM - Advertisement 2026.pdf" },
  { title: "Post Dispatch AGM 2026 Advertisement", url: "/reports/6.2 Post Dispatch AGM - Advertisement 2026.pdf" },
  { title: "AGM 2025 Advertisement", url: "/reports/AGM_2025_advertisement.pdf" },
  { title: "AGM 2025 - Email KYC Updation", url: "/reports/AGM 2025-EmailKYCupdation.pdf" },
  { title: "Postal Ballot Advertisement - July 2024", url: "/reports/Postal_Ballot_Advertisement_July_2024.pdf" },
  { title: "Postal Ballot Advertisement - March 2024", url: "/reports/Postal_Ballot_Advertisement_March_2024.pdf" },
  { title: "Newspaper Advertisement - Composite Scheme of Arrangement (English)", url: "/reports/The_Hindu_English_language.pdf" },
  { title: "Newspaper Advertisement - Composite Scheme of Arrangement (Tamil)", url: "/reports/Dinamani_Tamil_language.pdf" },
  { title: "Newspaper Advertisement - Composite Scheme of Arrangement (Hindi)", url: "/reports/Navbharat_Times_Hindi_language.pdf" },
  { title: "AGM 2024 - VC Facility", url: "/reports/AGM_2024_VC_Facility.pdf" },
  { title: "AGM Advertisement (Tamil)", url: "/reports/7thAGMNoticeinTamil.pdf" },
  { title: "AGM Advertisement (English)", url: "/reports/7thAGMNoticeinEnglish.pdf" },
],
"Credit Ratings": [
  { title: "Credit Ratings - 23rd January 2026", url: "/reports/disclosures/Credit_ratings_23rd_January_2026.pdf" },
  { title: "Credit Ratings - 10th October 2024", url: "/reports/disclosures/CreditRating_Oct_10_2024.pdf" },
],
"Financial Statements of Subsidiaries": [
  { title: "Subsidiaries Financials Report 2026", url: "/reports/disclosures/Subsidiaries_FinancialsReport_2026.pdf" },
  { title: "Subsidiaries Financials Report 2025", url: "/reports/disclosures/Subsidiaries_FinancialsReport_2025.pdf" },
  { title: "Subsidiaries Financials Report 2024", url: "/reports/disclosures/Annualreports_of_subsidiaries_2023_2024.pdf" },
],
"Secretarial Compliance Report": [
  { title: "Annual Secretarial Compliance Report 2026", url: "/reports/disclosures/Annual_Secretarial_Compliance_Report_2026.pdf" },
  { title: "Annual Secretarial Compliance Report 2025", url: "/reports/disclosures/Annual_Secretarial_Compliance_Report_2025.pdf" },
  { title: "Annual Secretarial Compliance Report 2024", url: "/reports/disclosures/Annual_Secretarial_Compliance_Report_2024.pdf" },
],
"Disclosure of the policy for determination of materiality of events or information": [
  { title: "Policy for Determination of Materiality of an Event", url: "/reports/disclosures/Policy_for_Determination_of_Materiality_of_an_Event.pdf" },
],
    "Board of Directors": [
      { title: "Board of Directors", url: "/reports/4. Board of Directors.pdf" },
    ],
    "Key Managerial Personnel authorised for determining materiality of events or information": [
      { title: "Mr Venu Srinivasan", text: "Chairman & Managing Director" },
      { title: "Dr Lakshmi Venu", text: "Managing Director" },
      { title: "Mr R Venkatesh", text: "Director & Chief Executive Officer" },
      { title: "Mr Hariharan V", text: "Chief Financial Officer" },
      {
    title: "Registered Office / Contact Details",
    text: "\"Chaitanya\", No.12, Khader Nawaz Khan Road, Nungambakkam, Chennai - 600 006, Tamil Nadu, India. | Tel: +91-44-2833 2115 | Email: corpsec@sundaramclayton.com",
  },
    ],
    "Statement of deviation(s) or variation(s) as specified in regulation 32": [
      { title: "Statement of deviation(s)/variation(s) - Quarter ended 31st December 2024", url: "/reports/sdv_Quarterended_31_Dec_2024.pdf" },
    ],
   
    "Dividend Distribution Policy": [
  { title: "Dividend Distribution Policy", url: "/reports/disclosures/Dividend_Distribution_Policy.pdf" },
],
"Annual return as provided under section 92 of the Companies Act, 2013": [
  { title: "MGT 7 - 2026", url: "/reports/disclosures/9. MGT 7 - 2026.pdf" },
  { title: "MGT 7 - 2025", url: "/reports/disclosures/MGT7-2025.pdf" },
  { title: "MGT 7 - 2024", url: "/reports/disclosures/MGT7_2024.pdf" },
  { title: "MGT 7 - 2023", url: "/reports/disclosures/MGT7_2023.pdf" },
  { title: "MGT 7 - 2022", url: "/reports/disclosures/MGT7_2022.pdf" },
  { title: "MGT 7 - 2021", url: "/reports/disclosures/MGT7_2021.pdf" },
  { title: "MGT 7 - 2020", url: "/reports/disclosures/MGT7_2020.pdf" },
  { title: "MGT 7 - 2019", url: "/reports/disclosures/MGT7_2019.pdf" },
  { title: "MGT 7 - 2018", url: "/reports/disclosures/MGT7_2018.pdf" },
],
    "Name of the debenture trustees with full contact details": [
      { title: "", text: "Nil" },
    ],
    "Corporate Social Responsibility Policy": [
      { title: "Corporate Social Responsibility Policy", url: "reports/Corporate_Social_Responsibility_Policy.pdf" },
    ],
    "Approved CSR Projects": [
      { title: "Approved CSR Projects", url: "/reports/Approved_CSR_Projects.pdf" },
    ],

    // ---- Information section ----
    "Key Managerial Personnel": [
      { title: "Mr. Venu Srinivasan", text: "Chairman & Managing Director" },
      { title: "Dr. Lakshmi Venu", text: "Managing Director" },
      { title: "Mr. R Venkatesh", text: "Director & Chief Executive Officer" },
      { title: "Mr. Hariharan V", text: "Chief Financial Officer" },
      { title: "Mr P D Dev Kishan", text: "Company Secretary" },
    ],
    "Investor Service Request": [
      { title: "Form ISR-1 - Request for Registering PAN KYC Details or Changes and or Updation", url: "/reports/Form%20ISR-1-%20Request%20for%20Registering%20PAN%20KYC%20Details%20or%20Changes%20and%20or%20Updation.pdf" },
      { title: "Form ISR-2 - Confirmation of Signature by bank", url: "/reports/Form%20ISR-2-%20Confirmation%20of%20Signature%20by%20bank.pdf" },
      { title: "Form ISR-3 - Declaration for opting-out of Nomination", url: "/reports/Form%20ISR-3-%20Declaration%20for%20opting-out%20of%20Nomination.pdf" },
      { title: "Form ISR-4 - Request for Issue of Duplicate Share Certificate and other Service Request", url: "/reports/Form%20ISR-4-%20Request%20for%20Issue%20of%20Duplicate%20Share%20Certificate%20and%20other%20Service%20Request.pdf" },
      { title: "Form SH-13 - Request for Registering Nomination", url: "/reports/Form%20SH-13-%20Request%20for%20Registering%20Nomination.pdf" },
      { title: "Form SH-14 - Request for Cancellation or Variation in Nomination", url: "/reports/Form%20SH-14-%20Request%20for%20Cancellation%20or%20Variation%20in%20Nomination.pdf" },
    ],

    // ---- Announcements section ----
    "Composite Scheme of Arrangement": [
      { title: "Information Memorandum", url: "/reports/Information_Memorandum.pdf" },
    ],
  };

  
  const disclosureCards = disclosuresContent[activeChild];

  return (
    <div className="reports-page">
      {/* BREADCRUMB */}
      <div className="breadcrumb">
        <span>Investors</span>
        {activeParent && (
          <>
            <FaChevronRight />
            <span>{activeParent}</span>
          </>
        )}
        {activeChild && (
          <>
            <FaChevronRight />
            <span className="active">{activeChild}</span>
          </>
        )}
      </div>

      <div className="reports-layout">
        {/* LEFT SIDEBAR */}
        <div className="reports-sidebar">
          {sidebarItems.map((item, i) => (
            <div key={i} className="sidebar-block">
              {/* PARENT */}
              <div
                className={`sidebar-item ${openIndex === i ? "active" : ""}`}
                onClick={() => {
                  setOpenIndex(openIndex === i ? null : i);
                  setActiveParent(item.title);
                  setActiveChild(null);
                }}
              >
                {item.title}
                {openIndex === i ? <FaChevronDown /> : <FaChevronRight />}
              </div>

              {/* CHILDREN */}
              {openIndex === i && (
                <div className="sidebar-dropdown">
                  {item.children.map((child, idx) => (
                    <div
                      key={idx}
                      className={`sidebar-subitem ${activeChild === child ? "active" : ""}`}
                      onClick={() => {
                        setActiveParent(item.title);
                        setActiveChild(child);
                      }}
                    >
                      {child}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* RIGHT CONTENT */}
        <div className="reports-content">
          {(activeChild === "Annual Reports" || activeChild === "Annual Report") &&
            reports.map((r, i) => (
              <a
                href={r.url}
                target="_blank"
                rel="noopener noreferrer"
                className="report-card"
                key={i}
              >
                <img src={pdfIcon} alt="PDF" />
                <div className="report-info">
                  <h4>Annual Report {r.year}</h4>
                  <p>Sundaram-Clayton Limited</p>
                </div>
                <FaDownload className="download-icon" />
              </a>
            ))}

          {/* ---- Qualified Institutional Placement: custom disclaimer flow ---- */}
          {activeChild === "Qualified Institutional Placement" ? (
            <div className="placement-disclaimer">
              {qipStep === "disclaimer" && (
                <>
                  <p style={{ fontWeight: "bold" }}>
                    IMPORTANT: You must read and agree with the terms and conditions of the following disclaimer before continuing.
                  </p>
                  <p>
                    PLEASE READ THIS NOTICE CAREFULLY. IT APPLIES TO ALL PERSONS WHO VIEW THIS WEBSITE. VIEWING THIS INFORMATION MAY NOT BE LAWFUL IN CERTAIN JURISDICTIONS. PLEASE NOTE THAT THE DISCLAIMER SET OUT BELOW MAY BE ALTERED OR UPDATED. YOU SHOULD READ IT IN FULL EACH TIME YOU VISIT THE WEBSITE. BY ACCESSING THIS INFORMATION ON THIS WEBSITE, YOU AGREE TO THE TERMS AND CONDITIONS BELOW, INCLUDING ANY MODIFICATIONS THAT MAY BE MADE TO THEM FROM TIME TO TIME.
                  </p>
                  <p>
                    THESE MATERIALS ARE NOT DIRECTED AT OR INTENDED TO BE ACCESSED BY PERSONS LOCATED IN THE UNITED STATES OR OTHER JURISDICTIONS OUTSIDE INDIA AND ARE INTENDED FOR DISTRIBUTION TO, AND USE BY, RESIDENTS OF INDIA ONLY.
                  </p>
                  <p>
                    THESE MATERIALS ARE BEING MADE AVAILABLE ON THIS WEBSITE BY SUNDARAM-CLAYTON LIMITED (THE "COMPANY") SOLELY TO COMPLY WITH THE SECURITIES AND EXCHANGE BOARD OF INDIA (ISSUE OF CAPITAL AND DISCLOSURE REQUIREMENTS) REGULATIONS, 2018, AS AMENDED ("SEBI ICDR REGULATIONS") AND THE COMPANIES ACT, 2013 AND THE RULES MADE THEREUNDER, EACH AS AMENDED ("COMPANIES ACT"). MAKING THE PRELIMINARY PLACEMENT DOCUMENT DATED OCTOBER 3, 2024 (THE "PRELIMINARY PLACEMENT DOCUMENT") AVAILABLE IN ELECTRONIC FORMAT ON THIS WEBSITE DOES NOT CONSTITUTE AN OFFER TO SELL OR THE SOLICITATION OF AN OFFER TO BUY EQUITY SHARES IN THE PROPOSED QUALIFIED INSTITUTIONS PLACEMENT ("ISSUE") IN ANY JURISDICTION.
                  </p>
                  <p>
                    NOTHING HEREIN CONSTITUTES AN OFFER OF SECURITIES FOR SALE IN ANY JURISDICTION WHERE IT IS UNLAWFUL TO DO SO. YOU ARE REMINDED THAT YOU HAVE ACCESSED THE PRELIMINARY PLACEMENT DOCUMENT ON THE BASIS THAT YOU ARE A PERSON INTO WHOSE POSSESSION THE DOCUMENTS MAY BE LAWFULLY DELIVERED IN ACCORDANCE WITH THE LAWS OF THE JURISDICTION IN WHICH YOU ARE LOCATED.
                  </p>
                  <p>
                    THE PRELIMINARY PLACEMENT DOCUMENT MAY NOT BE DOWNLOADED, DELIVERED, FORWARDED OR DISTRIBUTED, ELECTRONICALLY OR OTHERWISE, IN WHOLE OR IN PART, TO ANY OTHER PERSON AND MAY NOT BE REPRODUCED IN ANY MANNER WHATSOEVER. ANY DOWNLOADING, FORWARDING, DELIVERY, DISTRIBUTION OR REPRODUCTION OF THE PRELIMINARY PLACEMENT DOCUMENT IN WHOLE OR IN PART IS UNAUTHORIZED. FAILURE TO COMPLY WITH THIS DISCLAIMER MAY RESULT IN A VIOLATION OF THE APPLICABLE LAWS.
                  </p>
                  <p style={{ fontWeight: "bold", textDecoration: "underline" }}>
                    YOU ARE ACCESSING THE MATERIALS ON THIS WEBSITE ON THE BASIS THAT YOU ARE A PERSON INTO WHOSE POSSESSION THESE MATERIAL MAY BE LAWFULLY DELIVERED IN ACCORDANCE WITH THE LAWS OF THE JURISDICTION IN WHICH YOU ARE LOCATED. IF YOU ARE NOT PERMITTED TO VIEW THE MATERIALS ON THIS WEBSITE OR ARE IN ANY DOUBT AS TO WHETHER YOU ARE PERMITTED TO VIEW THESE MATERIALS, PLEASE EXIT THIS WEBPAGE.
                  </p>

                  <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "16px" }}>
                    <input
                      type="checkbox"
                      checked={qipAgreed}
                      onChange={(e) => setQipAgreed(e.target.checked)}
                    />
                    I certify that I am authorized to access this site
                  </label>

                  <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                    <button
                      className="placement-btn"
                      disabled={!qipAgreed}
                      onClick={() => setQipStep("country")}
                    >
                      I Confirm
                    </button>
                    <button
                      className="placement-btn"
                      onClick={() => {
                        setActiveChild(null);
                        setActiveParent(null);
                      }}
                    >
                      I Do Not Confirm
                    </button>
                  </div>
                </>
              )}

              {qipStep === "country" && (
                <>
                  <p>Please indicate which country you are accessing the document from:</p>
                  <select
                    value={qipCountry}
                    onChange={(e) => handleQipCountrySelect(e.target.value)}
                    style={{ padding: "8px", minWidth: "220px" }}
                  >
                    <option value="">Select Countries</option>
                    <option value="India">India</option>
                    <option value="United States">United States</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="Singapore">Singapore</option>
                    <option value="UAE">UAE</option>
                    <option value="Other">Other</option>
                  </select>
                </>
              )}

              {qipStep === "restricted" && (
                <p>
                  Access to this document is restricted for the selected jurisdiction. This Preliminary Placement Document is intended for distribution to, and use by, residents of India only.
                </p>
              )}
            </div>
          ) : (
            <>
              {disclosureCards &&
                disclosureCards.map((item, i) =>
                  item.url ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="report-card"
                      key={i}
                    >
                      {item.isPage ? (
                        <FaGlobe className="type-icon page-icon" />
                      ) : (
                        <img src={pdfIcon} alt="PDF" />
                      )}
                      <div className="report-info">
                        <h4>{item.title}</h4>
                        <p>{item.subtitle || "Sundaram-Clayton Limited"}</p>
                        {item.note && <span className="report-note">{item.note}</span>}
                      </div>
                      {item.isPage ? (
                        <FaExternalLinkAlt className="download-icon" />
                      ) : (
                        <FaDownload className="download-icon" />
                      )}
                    </a>
                  ) : (
                    <div
                      className={`report-card report-card-text ${
                        activeChild === "Key Managerial Personnel" ||
                        activeChild ===
                          "Key Managerial Personnel authorised for determining materiality of events or information"
                          ? "kmp-card"
                          : ""
                      }`}
                      key={i}
                    >
                      <div className="report-info">
                        <h4>{item.title}</h4>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  )
                )}

              {activeChild &&
                activeChild !== "Annual Reports" &&
                activeChild !== "Annual Report" &&
                !disclosureCards && (
                  <div className="report-card report-card-text">
                    <div className="report-info">
                      <h4>Content coming soon</h4>
                      <p>This section will be updated shortly.</p>
                    </div>
                  </div>
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
